import { View, Text } from '@react-pdf/renderer';
import { Interval } from 'luxon';
import { CANDLE_GAP, CANDLE_PADDING_LEFT, CANDLE_WIDTH, HOUR_NUMBER_WIDTH, LINE_MARGIN_LEFT, ROW_HEIGHT, diagramStyle } from './style';

export interface IDiagramProps {
    hoursPerDay: number[];
    interval: Interval;
}

const calculateLeft = (index: number) => {
    const postionZero = HOUR_NUMBER_WIDTH + LINE_MARGIN_LEFT + CANDLE_PADDING_LEFT;
    return postionZero + index * CANDLE_WIDTH + index * CANDLE_GAP;
};

const calculateTextLeft = (index: number) => {
    const postionZero = HOUR_NUMBER_WIDTH + LINE_MARGIN_LEFT;
    return postionZero + index * CANDLE_WIDTH + index * CANDLE_GAP;
};

const calculateMaxDisplayHours = (hoursPerDay: number[]) => {
    const maxLogedHours = Math.ceil(Math.max(...hoursPerDay));
    if (maxLogedHours < 12) return 13;

    if (maxLogedHours % 2 === 0) return maxLogedHours + 1;

    return maxLogedHours + 2;
};

export const Diagram = ({ hoursPerDay, interval }: IDiagramProps) => {
    const maxDisplayHours = calculateMaxDisplayHours(hoursPerDay);

    const hours = Array.from(Array(maxDisplayHours).keys())
        .reverse()
        .filter(e => e % 2 === 0);

    const dates = interval.set({ end: interval.end.plus({ day: 1 }) }).splitBy({ day: 1 });

    return (
        <View style={diagramStyle.diagram}>
            <>
                {hours.map(h => (
                    <View key={h} style={diagramStyle.hours}>
                        <Text style={diagramStyle.hour} key={h}>
                            {`${h}h`}
                        </Text>
                        <View style={diagramStyle.line}></View>
                    </View>
                ))}
                {hoursPerDay.map((hours, i) => (
                    <View
                        key={hours}
                        style={{
                            position: 'absolute',
                            height: (ROW_HEIGHT * hours) / 2,
                            width: CANDLE_WIDTH,
                            backgroundColor: '#4B99F5',
                            bottom: 22,
                            borderRadius: 2,
                            left: calculateLeft(i),
                        }}
                    ></View>
                ))}
                {dates.map((date, i) => (
                    <Text
                        key={date.start.toString()}
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            left: calculateTextLeft(i),
                            fontSize: 8,
                            color: '#455166',
                            transform: 'rotate(-59.768deg)',
                        }}
                    >
                        {date.start.toFormat('dd.MM.')}
                    </Text>
                ))}
            </>
        </View>
    );
};
